<template>
  <div>
    <h3 class="subtitle-1 mt-8 mb-2 text-uppercase font-weight-bold text-center">{{ title }}</h3>
    <p class="body-1 mb-8 text-center">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: ["title", "subtitle"]
};
</script>